/**
 * Maps Firebase auth error codes to user-friendly messages
 */
export const getAuthErrorMessage = (error) => {
  // Handle null/undefined
  if (!error) return 'An unknown error occurred';

  // Get error code
  const code = error.code || '';

  // Map Firebase error codes to friendly messages
  const errorMessages = {
    // Email/Password Registration Errors
    'auth/email-already-in-use': 'An account with this email already exists. Go back and sign in instead.',
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/operation-not-allowed': 'Email/password accounts are not enabled. Please contact support.',
    'auth/weak-password': 'Password is too weak. Please use at least 8 characters.',

    // Login Errors
    'auth/user-disabled': 'This account has been disabled. Please contact support.',
    'auth/user-not-found': 'No account with this email. Tap "Create account" below to get started.',
    'auth/wrong-password': 'Incorrect password. Try again or tap "Forgot?" to reset it.',
    'auth/invalid-credential': 'No account found, or wrong password. If you\'re new, tap "Create account" below.',
    'auth/too-many-requests': 'Too many failed attempts. Please try again later or reset your password.',

    // Google Sign-In Errors
    'auth/popup-closed-by-user': 'Sign-in cancelled. Please try again.',
    'auth/popup-blocked': 'Pop-up blocked by your browser. Please allow pop-ups and try again.',
    'auth/cancelled-popup-request': 'Sign-in cancelled. Please try again.',
    'auth/account-exists-with-different-credential': 'This email is already linked to another sign-in method. Please sign in with the method you used originally (Google, Apple, or email).',

    // Password Reset Errors
    'auth/expired-action-code': 'This password reset link has expired. Please request a new one.',
    'auth/invalid-action-code': 'This password reset link is invalid. Please request a new one.',

    // Network Errors
    'auth/network-request-failed': 'Network error. Please check your connection and try again.',
    'auth/timeout': 'Request timed out. Please try again.',

    // General Errors
    'auth/internal-error': 'Something went wrong. Please try again.',
    'auth/invalid-api-key': 'Configuration error. Please contact support.',
    'auth/app-deleted': 'Application error. Please contact support.',
    'auth/app-not-authorized': 'Application error. Please contact support.',
    'auth/argument-error': 'Invalid request. Please try again.',
    'auth/invalid-user-token': 'Your session has expired. Please sign in again.',
    'auth/requires-recent-login': 'Please sign in again to continue.',
    'auth/unauthorized-domain': 'This application is not authorized. Please contact support.',
  };

  // Return mapped message or generic message
  return errorMessages[code] || error.message || 'An unexpected error occurred. Please try again.';
};
